import { render } from "./GanttPublicView.vue?vue&type=template&id=4b507f2a&scoped=true&ts=true"
import script from "./GanttPublicView.vue?vue&type=script&lang=ts"
export * from "./GanttPublicView.vue?vue&type=script&lang=ts"

import "./GanttPublicView.vue?vue&type=style&index=0&id=4b507f2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b507f2a"]])

export default __exports__